import { useState, useRef } from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import './NewsCarousel.css';
import NewsCard from '../NewsCard';
import useViewport from '../../../hooks/useViewPort';

const NewsCarousel = ({
	visibleItems = 3,
	// itemWidth = 315,
	itemHeight = 278,
	itemMargin = 8,
	news = [],
}) => {
	const { width } = useViewport();
	const itemWidth = width < 400 ? 375 : width < 768 ? 400 : 600;

	const totalItems = news?.length;
	const step = itemWidth + itemMargin * 2;
	const maxTranslate = 0;
	const minTranslate = Math.min(visibleItems - totalItems, 0) * step;

	// current x offset in px
	const [position, setPosition] = useState(0);
	// refs to track drag
	const dragging = useRef(false);
	const startX = useRef(0);
	const startPos = useRef(0);

	// --- Handlers ---
	const handlePointerDown = (clientX) => {
		dragging.current = true;
		startX.current = clientX;
		startPos.current = position;
	};

	const handlePointerMove = (clientX) => {
		if (!dragging.current) return;
		const delta = clientX - startX.current;
		let next = startPos.current + delta;

		// clamp
		next = Math.max(minTranslate, Math.min(maxTranslate, next));

		setPosition(next);
	};

	const handlePointerUp = () => {
		dragging.current = false;
	};

	// Button nudges
	const prev = () => setPosition((p) => Math.min(p + step, maxTranslate));
	const next = () => setPosition((p) => Math.max(p - step, minTranslate));

	const sliderStyle = {
		display: 'flex',
		transform: `translateX(${position}px)`,
		transition: dragging.current ? 'none' : 'transform 0.3s ease',
	};
	const slideStyle = {
		flexShrink: 0,
		width: `${itemWidth}px`,
		maxWidth: `${itemWidth}px`,
		height: `${itemHeight}px`,
		margin: `0 ${itemMargin}px`,
		boxSizing: 'border-box',
	};

	return (
		<div className='news-carousel-main-container'>
			<div
				className='news-mobile-carousel-container'
				onMouseDown={(e) => handlePointerDown(e.clientX)}
				onMouseMove={(e) => handlePointerMove(e.clientX)}
				onMouseUp={handlePointerUp}
				onMouseLeave={handlePointerUp}
				onTouchStart={(e) => handlePointerDown(e.touches[0].clientX)}
				onTouchMove={(e) => handlePointerMove(e.touches[0].clientX)}
				onTouchEnd={handlePointerUp}
			>
				<div style={sliderStyle}>
					{news.slice(0, 10).map((item, i) => (
						<div key={i} style={slideStyle}>
							<NewsCard
								backgroundImage={item.image_url}
								title={item?.title}
								description={item?.description}
								content={item?.rich_text}
							/>
						</div>
					))}
				</div>
			</div>

			<div className='news-carousel-btn-container'>
				<button
					onClick={prev}
					disabled={position >= maxTranslate}
					className='news-carousel-btn'
					style={{
						opacity: position >= maxTranslate ? 0.3 : 1,
					}}
					aria-label='Previous'
				>
					<FaChevronLeft />
				</button>

				<button
					onClick={next}
					disabled={position <= minTranslate}
					className='news-carousel-btn'
					style={{
						opacity: position <= minTranslate ? 0.3 : 1,
					}}
					aria-label='Next'
				>
					<FaChevronRight />
				</button>
			</div>
		</div>
	);
};

export default NewsCarousel;
